// import { http } from "../http-common";
import { httpPOC, http } from "../http-common";

const FetchDropdown = query => {
  return http.get('/questionnaire');
  // return http.get('/questionnaire');

};
const FetchModules = (query) => {
  return http.get(`/questionnaire/module-list/${query.cropYearId}/${query.cropStageId}`);
  // return http.get(`/questionnaire/module-list/a3a28449-09be-4b14-ae84-3ef34cf22adc/389AE92C-85FC-4AF2-A623-3574B733BFA0`);
}

const FetchModulesList = (query) => {
  // return http.get(`/questionnaire/search/${query.cropYearId}/${query.cropStageId}?${query.params.toString()}`);
  return http.get(`/questionnaire/module-list/${query.cropYearId}/${query.cropStageId}`);
  // return http.get(`/questionnaire/module-list/${query.cropYearId}/${query.cropStageId}?${query.cropStageId}`);

  // return http.get(`/questionnaire/module-list/a3a28449-09be-4b14-ae84-3ef34cf22adc/389AE92C-85FC-4AF2-A623-3574B733BFA0`);
}

const FetchSubModules = (query) => {
  if(query?.userInput != undefined && query?.userInput != ""){
    return http.get(`/questionnaire/question-modules/${query.cropYearId}/${query.moduleId}?userInput=${query.userInput}`);
  }else{
  return http.get(`/questionnaire/question-modules/${query.cropYearId}/${query.moduleId}`);
  }
  // return http.get('/questionnaire/A3A28449-09BE-4B14-AE84-3EF34CF22ADC/8D71F115-A590-487B-ADDE-B30AB35CCE4D/?active=true&mandatory=true&audit=false')
  // return http.get(`/questionnaire/A3A28449-09BE-4B14-AE84-3EF34CF22ADC/8D71F115-A590-487B-ADDE-B30AB35CCE4D/`);

}
const searchQuestion = (query) => {
  return http.get(`/questionnaire/search/${query.selectedCropYear}/${query.selectedCropStages}?${query.params.toString()}`);
}
const FetchQuestionById = (query) => {

  return http.get(`/questionnaire/${query?.questionId}`);
}
const FetchReferenceQuestions = (query) => {

  return http.get(`/questionnaire/reference-questions?cropYearId=${query.cropYearId}`);
}
const FetchCode = (query) => {
  const encodedModuelName = encodeURIComponent(query.moduelName);
  const encodedSubModuelName = encodeURIComponent(query.subModuelName);
  const encodedCropStageName = encodeURIComponent(query.cropStageName);
  return http.get(`/questionnaire/question-code?cropStageId=${query.cropStageId}&moduleId=${query.moudleId}&moduleName=${encodedModuelName}&cropStageName=${encodedCropStageName}`);

}

const SearchParent = (query) => {
  return http.get(`/questionnaire/search-parent-question?${query?.params}`);
}
const FetchModSub = (query) => {
  return http.get(`/questionnaire/submodule-list/${query.cropYearId}/${query.cropStageId}`);
  // return http.get(`/questionnaire/module-list/a3a28449-09be-4b14-ae84-3ef34cf22adc/389AE92C-85FC-4AF2-A623-3574B733BFA0`);
}
const FetchQuestionSequence = (query) => {
  // if (query?.parentQuestionId) {
  //   return http.get(`/questionnaire/question-sequence?subModuleId=${query.subModuelId}&parentQuestionId=${query.parentQuestionId}`);
  // } else {
  //   return http.get(`/questionnaire/question-sequence?subModuelId=${query.subModuelId}`);
  // }
  return http.get(`/questionnaire/question-sequence?moduleId=${query.moduelId}`);

  return http.get(`/questionnaire/question-sequence?subModuelId=${query.subModuelId}`);
  // return http.get(`/questionnaire/module-list/a3a28449-09be-4b14-ae84-3ef34cf22adc/389AE92C-85FC-4AF2-A623-3574B733BFA0`);
}
const saveQuestion = (data) => {
  return http.post(`/questionnaire/save-questionnaire`, data);
  // return http.get(`/questionnaire/module-list/a3a28449-09be-4b14-ae84-3ef34cf22adc/389AE92C-85FC-4AF2-A623-3574B733BFA0`);
}
const updateQuestion = (data) => {
  return http.put(`/questionnaire/update-questionnaire`, data);
  // return http.get(`/questionnaire/module-list/a3a28449-09be-4b14-ae84-3ef34cf22adc/389AE92C-85FC-4AF2-A623-3574B733BFA0`);
}

const updateByCheckbox = (query) => {
  // return http.put(`/questionnaire/${query.questionId}?${query.params.toString()}`);
  return http.put(`/questionnaire/update-questionnaire-attributes`,{...query?.data,questionId:query?.questionId,modifiedByUser:query?.modifiedByUser});
}
const publishQuestion = (data) => {
  // return http.put(`questionnaire/update-unpublish-questions/${data?.questionIds}`);
  return http.put(`questionnaire/update-unpublish-questions`,{questionIds:data?.questionIds,modifiedByUser:data?.modifiedByUser});

}
const getReferenceQuestionsCalculation = (query) => {
  return http.get(`questionnaire/reference-questions?cropYearId=${query.cropYearId}&cropStageId=${query?.cropStageId}&multiInstance=false`);

}
const exportQuestionData = (query) => {
  return http.get(`questionnaire/export-questions?${query.params.toString()}`);
};
const QuestionnareService = {
  exportQuestionData,
  FetchDropdown,
  FetchModules,
  FetchModulesList,
  FetchSubModules,
  searchQuestion,
  FetchQuestionById,
  FetchReferenceQuestions,
  FetchCode,
  SearchParent,
  FetchModSub,
  FetchQuestionSequence,
  saveQuestion,
  updateByCheckbox,
  updateQuestion,
  publishQuestion,
  getReferenceQuestionsCalculation
};

export default QuestionnareService;

